module.exports = __webpack_public_path__ + "img/TrialPlus.6cdedf32.png";